module.exports = __webpack_public_path__ + "img/a9f83fcc-1df9-44b3-8b80-256584b42aff.e80d49b5.png";